import React from 'react';
import { observer } from 'mobx-react';

import { constants } from '../../../config';
import { ScreenStore } from '../../../stores/ScreenStore';
import { HomeNavbar } from '../../../common/home-navbar';
import { SessionStore } from '../../../stores/SessionStore';
import { PhoneStore } from '../../../stores/PhoneStore';
import { USER_TYPES } from '../../../models/User';
import { AppRedirect, routeNaming, AppLink } from '../../../routes';
import { MyAccountMenu } from '../my-account-menu';
import { Footer } from '../../../common/footer';
import { Spinner } from '../../../common/spinner';
import { PhoneCard } from '../phone-card';
import { Validator } from '../../../helpers/Validator';
import DeleteIcon from '../icon-trash.svg';
import styles from './MyPhoneNumbers.css';
import { SEO } from '../../../common/seo';

const MyPhoneNumbers = observer(class MyPhoneNumbers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addingPhoneNumber: false,
      newPhoneNumber: '',
      error: null,
    };

    this._addPhoneNumber = this._addPhoneNumber.bind(this);
    this._changeNewPhone = this._changeNewPhone.bind(this);
    this._deleteNewPhone = this._deleteNewPhone.bind(this);
    this._savePhoneNumber = this._savePhoneNumber.bind(this);
  }
  componentDidMount() {
    PhoneStore.getPhones();
  }

  _addPhoneNumber() {
    this.setState({ addingPhoneNumber: true });
  }

  _changeNewPhone(event) {
    const { target: { value } } = event;

    let newErrorVal = null;
    const filterPhones = PhoneStore.phones.filter(ph => ph.number === value);
    if (filterPhones.length > 0) {
      newErrorVal = 'El teléfono ya fue agregado';
    }
    this.setState({
      newPhoneNumber: value,
      error: newErrorVal,
    });
  }

  _deleteNewPhone() {
    this.setState({
      newPhoneNumber: '',
      addingPhoneNumber: false,
    });
  }

  async _savePhoneNumber() {
    this.setState({
      error: null,
    });
    if (this.state.newPhoneNumber.trim() === '') {
      return;
    }
    if (!Validator.isPhone(this.state.newPhoneNumber)) {
      this.setState({
        error: 'El formato de número de teléfono es incorrecto',
      });
      return;
    }

    await PhoneStore.addPhone(this.state.newPhoneNumber);
    this.setState({
      newPhoneNumber: '',
      addingPhoneNumber: false,
    });
  }

  render() {
    if (!SessionStore.loggedIn) {
      return (
        <AppRedirect routeName={routeNaming.HOME} />
      );
    }

    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
    return (
      <div className={styles.container}>
        <SEO
          title="Mis teléfonos"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainContent}>
          {
            !mobileVersion &&
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Mi Cuenta</h1>
              <h2 className={styles.subtitle}>
                <span>Hola, </span>
                {SessionStore.user.type === USER_TYPES.COMPANY ?
                  SessionStore.user.fictitiousName :
                  SessionStore.user.names}
                !
              </h2>
            </div>
          }
          {
            mobileVersion &&
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.MY_ACCOUNT_MENU_MOBILE}
              >
                Mi Cuenta
              </AppLink>
              <span> &gt; Mis teléfonos</span>
            </p>
          }
          <div className={styles.content}>
            {
              !mobileVersion && <MyAccountMenu indexSelectedItem={2} />
            }
            <div className={styles.myPhonesContainer}>
              <div className={styles.headerContainer}>
                <h2 className={styles.header}>Mis teléfonos</h2>
              </div>
              <div className={styles.myPhones}>
                <p className={styles.fieldName}>Teléfonos de contacto</p>
                <div className={styles.phoneCards}>
                  {
                    PhoneStore.loadingPhones &&
                    <Spinner />
                  }
                  {
                    PhoneStore.phones.map(phone => (
                      <PhoneCard phone={phone} key={phone.id} />
                    ))
                  }
                  {
                    this.state.addingPhoneNumber &&
                    <div className={styles.phoneContainer}>
                      <input
                        className={styles.newNumber}
                        value={this.state.newPhoneNumber}
                        type="text"
                        name="phone"
                        placeholder="09####### o [2 o 4]#######"
                        onChange={this._changeNewPhone}
                      />
                      <div className={styles.actionBtnContainer}>
                        <button onClick={this._deleteNewPhone} className={styles.deleteButton}>
                          <img
                            src={DeleteIcon}
                            alt="delete"
                          />
                        </button>
                        <button
                          className={styles.saveButton}
                          onClick={this._savePhoneNumber}
                          disabled={!!this.state.error
                          || (this.state.newPhoneNumber && !this.state.newPhoneNumber.trim())}
                        >
                          GUARDAR
                        </button>
                      </div>
                    </div>
                  }
                  { this.state.error &&
                    <p className={styles.error}>
                      {this.state.error}
                    </p>}
                  {
                    !this.state.addingPhoneNumber &&
                    <button className={styles.addButton} onClick={this._addPhoneNumber}>
                      AGREGAR TELÉFONO
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
});

export { MyPhoneNumbers };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-phone-numbers/MyPhoneNumbers.jsx